import { observer } from "mobx-react"
import DOMPurify from "dompurify"
import Image from "./Image"
import FormStore from "../../Configs/Store/forms"

const DyCard = ({ title, icon, icon2, icon3, content, className, id, onClick, icon3Click, imgheight, imgwidth, imgalt, deferImages = true, ...props }) => {
  return (
    <div className={className} onClick={onClick} id={id}>
      {icon && (
        <div className="iconWrap">
          {/* <img src={`assets/${icon}.svg`} height={imgheight} width={imgwidth} alt={imgalt} /> */}
          <Image src={icon} height={imgheight} width={imgwidth} alt={imgalt} defer={`${deferImages ? true : false}`} />
        </div>
      )}
      <div className="contentWrap">
        {title && <div className="title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />}
        {icon2 && (
          <div className="iconWrap">
            <Image src={icon2} height={imgheight} width={imgwidth} alt={imgalt} defer={`${deferImages ? true : false}`} />
          </div>
        )}
        {content && <div className="content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content?.replace(/\{\{fundCount\}\}/g, `${FormStore.api_fundCount}`)) }} />}
      </div>
      {icon3 && (
        <div className="iconWrap" onClick={icon3Click}>
          <Image src={icon3} height={imgheight} width={imgwidth} alt={imgalt} defer={`${deferImages ? true : false}`} />
        </div>
      )}
    </div>
  )
}

export default DyCard
